__turbopack_context__.v({
  "base": "GameCard-module__LTzonq__base",
  "blur": "GameCard-module__LTzonq__blur",
  "blurContainer": "GameCard-module__LTzonq__blurContainer",
  "card": "GameCard-module__LTzonq__card",
  "cardImage": "GameCard-module__LTzonq__cardImage",
  "content": "GameCard-module__LTzonq__content",
  "data": "GameCard-module__LTzonq__data",
  "genre": "GameCard-module__LTzonq__genre",
  "genres": "GameCard-module__LTzonq__genres",
  "label": "GameCard-module__LTzonq__label",
  "maintenanceIcon": "GameCard-module__LTzonq__maintenanceIcon",
  "maintenanceIconHovered": "GameCard-module__LTzonq__maintenanceIconHovered",
  "mirror": "GameCard-module__LTzonq__mirror",
  "trailer": "GameCard-module__LTzonq__trailer",
  "vertical": "GameCard-module__LTzonq__vertical",
});
